/**
 * Turning machine-shaped text into something a person reads: collapsing the
 * whitespace a crawled title arrived with, and spacing out the underscores in
 * a stored key. Presentation only — nothing here decides anything, and no
 * caller reads the result back to recover what it was.
 */

const COLLAPSED_WHITESPACE = /\s+/g;
const UNDERSCORES = /_/g;
const NON_SLUG = /[^a-z0-9]+/g;
const SLUG_EDGES = /^-+|-+$/g;

/** One space between words, none at the ends. */
export function collapseWhitespace(value: string): string {
  return value.trim().replace(COLLAPSED_WHITESPACE, " ");
}

/** A snake_case key spaced out for display. */
export function spacedKey(value: string): string {
  return value.replace(UNDERSCORES, " ");
}

/** A lowercase, hyphenated fragment safe to use in an id or an anchor. */
export function slug(value: string): string {
  return value.toLowerCase().replace(NON_SLUG, "-").replace(SLUG_EDGES, "");
}
